import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootState } from '../../../root-store/root.state';
import { seChangeTheme } from '../../../root-store/root.actions';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'se-header-options',
    templateUrl: './se-header-options.component.html',
    styleUrls: ['./se-header-options.component.scss'],
})
export class SeHeaderOptionsComponent {
    constructor(private store: Store<RootState>,
        private translateService: TranslateService) { }


    onChangeThemeDark() {
        this.store.dispatch(seChangeTheme({ theme: 'dark' }));
    }

    onChangeThemeLight() {
        this.store.dispatch(seChangeTheme({ theme: 'light' }));
    }

    getOptionsTranslation() {
       return this.translateService.instant("Options");
    }
}
